import { Provider } from '@angular/core'

import { ForgotPasswordViewModel, NewPasswordViewModel } from '@ti/shared/auth-ui/models'

import { AdminForgotPasswordViewModel } from './forgot-password.view-model'
import { AdminNewPasswordViewModel } from './new-password.view-model'

export * from './forgot-password.view-model'
export * from './new-password.view-model'

export const AUTH_PROVIDERS: Provider[] = [
  {
    provide: NewPasswordViewModel,
    useClass: AdminNewPasswordViewModel,
  },
  {
    provide: ForgotPasswordViewModel,
    useClass: AdminForgotPasswordViewModel,
  },
]
